import { ReactElement } from 'react';
import { Box } from '@material-ui/core';
import { CreateButton } from '../../atoms/create-button/create-button.component';

import './content-manager-overview-header.styles.scss';

export interface IContentManagerOverviewHeaderProps {
	onCreateButtonClicked: () => void;
}

export function ContentManagerOverviewHeader(
	props: IContentManagerOverviewHeaderProps
): ReactElement {
	const { onCreateButtonClicked } = props;

	return (
		<Box className="content-manager-overview-header">
			<CreateButton onClick={onCreateButtonClicked} />
		</Box>
	);
}
